import React from "react";
import useAppContext from "state/AppContext";
import { Button } from "@material-tailwind/react";

export default function JobPostingHeader(props) {
  const appContext = useAppContext();
  const { jobPosting } = appContext.selectedOrder;
  const { jobTitle, jobLocation, jobTeam } = jobPosting;

  return (
    <div className="mb-12 text-center">
      <header className="mb-4">
        <h6 className="text-xs uppercase text-gray-700 font-bold mb-2">Job Posting</h6>
        <h2 className="text-5xl font-bold mb-2">{jobTitle}</h2>
        <h3 className="text-xl text-gray-800">{jobLocation}</h3>
        <h4 className="text-lg text-gray-700">{jobTeam}</h4>
      </header>
      <div className="flex justify-center">
        <Button className="rounded-full">Apply Now</Button>
      </div>
    </div>
  );
}
